import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeUk from '@angular/common/locales/uk';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { NgxMaskOptions, provideNgxMask } from 'ngx-mask';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { CustomErrorHandler } from './common/utils/custom-error-handler';
import { AuthService } from './auth/services/auth.service';
import { ApiForbiddenInterceptor } from './common/interceptors/api-forbidden.interceptor';
import { JwtInterceptor } from './common/interceptors/jwt.interceptor';


registerLocaleData(localeUk);

const config: SocketIoConfig = { url: environment.socketUrl, options: {} };

const maskConfig: NgxMaskOptions = {
  validation: true,
};

function initSecurityService(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      authService.init().subscribe({
        next: () => {
          resolve(true);
        },
        error: () => {
          resolve(false);
        },
      });
    });
  };
}

@NgModule({ declarations: [AppComponent],
    exports: [],
    bootstrap: [AppComponent], imports: [AuthModule,
        SocketIoModule.forRoot(config),
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSnackBarModule,
        MatDialogModule,
        MatNativeDateModule], providers: [
        provideNgxMask(maskConfig),
        {
            provide: APP_INITIALIZER,
            useFactory: initSecurityService,
            deps: [AuthService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiForbiddenInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'uk'
        },
        {
            provide: ErrorHandler,
            useClass: CustomErrorHandler,
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {
            },
            deps: [Sentry.TraceService],
            multi: true,
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule {
}
